import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d159c460"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Questionnaire" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*"),
  /*#__PURE__*/_createTextVNode("请留下电话号码，稍后主动联系您")
], -1))
const _hoisted_5 = { class: "desc" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.detail.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString($setup.detail.content), 1),
    _hoisted_4,
    _createVNode(_component_VanField, {
      class: "name",
      modelValue: $setup.submitData.mobile,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.submitData.mobile) = $event)),
      placeholder: "请输入手机号码",
      border: false
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_5, _toDisplayString($setup.detail.describe), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_VanButton, {
        type: "primary",
        block: "",
        onClick: $setup.submit
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}